export default __webpack_public_path__ + "static/10-d2548ad736f25fdf13223ab62dd8fcba.jpg";